__turbopack_context__.v({
  "body": "XckXDW_body",
  "body--full-width": "XckXDW_body--full-width",
  "footer": "XckXDW_footer",
  "header": "XckXDW_header",
  "main": "XckXDW_main",
  "marginX": "XckXDW_marginX",
  "marginY": "XckXDW_marginY",
  "scroll-animation": "XckXDW_scroll-animation",
  "shimmer": "XckXDW_shimmer",
  "text-bar-sweep": "XckXDW_text-bar-sweep",
});
